import React, { useRef, useState } from 'react';
import { copyToClipboard } from 'Src/common/utilities/dom_utils';
import { announceToScreenReader } from 'Src/common/utilities/a11y_util';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

function LinkBlock({ title, url, accessibilityContrast = false }) {
  const [showCopiedMsg, toggleCopiedMsg] = useState(false);
  const announcementRegionId = useRef(`share-block-announcement-${Math.random().toString(36).substr(2, 8)}`);
  const urlId = useRef(`share-block-url-${Math.random().toString(36).substr(2, 8)}`);
  const linkRef = useRef(null);
  // Several blocks can sit in one modal (admin Forms > Share), so name each button after its heading
  const copyLabel = typeof title === 'string' && title ? `Copy link: ${title.toLowerCase()}` : 'Copy link';

  function Copied(linkUrl) {
    copyToClipboard(linkUrl);
    // copyToClipboard() drops focus to <body>, which can land outside the modal/dialog
    // this control lives in; put it back on this button so focus stays inside.
    if (linkRef.current) {
      linkRef.current.focus();
    }
    toggleCopiedMsg(true);
    announceToScreenReader('Link copied to clipboard!', announcementRegionId.current);
    setTimeout(() => {
      toggleCopiedMsg(false);
    }, 3000);
  }

  function handleCopyKeyDown(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      Copied(url);
    }
  }

  return (
    <div className={`link-block-wrapper ${accessibilityContrast ? 'accessibility-contrast' : ''}`}>
      <If condition={title}>
        <div className="link-block-header arc-H100 arc-color-B45">{title}</div>
      </If>
      <div
        ref={linkRef}
        className={`link-block-body ${showCopiedMsg ? 'show-msg' : ''}`}
        onClick={() => Copied(url)}
        onKeyDown={handleCopyKeyDown}
        aria-label={copyLabel}
        aria-describedby={urlId.current}
        role="button"
        tabIndex={0}>
        <span className="link-icon">
          <FontAwesomeIcon icon={faCopy} />
        </span>
        <span id={urlId.current} className="link-url arc-support arc-text-ellipsis arc-color-B85">
          {url}
        </span>
      </div>
      <div className={`link-msg arc-support ${showCopiedMsg ? 'show' : ''}`} aria-hidden="true">
        <FontAwesomeIcon icon={faCheck} className="mr8" />
        <I18nCustomFormatter id="link-copied-to-clipboard" defaultMessage="Link copied to clipboard!" />
      </div>
      {/* The one spoken copy message; it is re-announced on every copy, the visible message above is aria-hidden */}
      <div
        id={announcementRegionId.current}
        className="arc-sr-only"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      />
    </div>
  );
}

export default LinkBlock;
